export const PAYER_SECTION_ROUTES = {
    PAYER: "payer",
    ADD: "add",
    EDIT: "edit",
    PAYER_ADDED: "payeradded",
    BULK_PAYER_ADDED: "bulkuploadsuccess",

    ADD_MEMBER_USERS: "addmemberusers",
    MEMBER_USERS_ADDED: "memberusersadded",
}